<template src="./ViewSolicitudHistorica.html"></template>

<script>
import {Breadcrumb, BreadcrumbItem, Divider} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import moment from "moment";
import {requestSolicitudMixin} from "@/api/solicitudPH";
import SolicitudHistoricaDetail from "@/components/Shared/SolicitudHistoricaDetail/SolicitudHistoricaDetail";
import {RouterMixin} from "@/mixins/routerMixin";

export default {
  name: "ViewSolicitudHistorica",
  components: {
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    SolicitudHistoricaDetail
  },
  mixins: [
    ScreenSizeMixin,
    NotifyMixin,
    requestSolicitudMixin,
    RouterMixin
  ],
  data: () => ({
    loading: true,
    errored: false,
    inRoute: false,
    model: {
      id: "",
      rut: "",
      nombreCompleto: "",
      fechaIngreso: '',
      email: "",
      estado: "",
      estadoCodigo: 0,
      fecha: '',
      hora: ''
    },
  }),
  props: {
    id: {
      type: String,
      required: false
    }
  },
  beforeMount() {
    this.getId()
    this.solicitudHistorica()
  },
  computed: {
    getShadow: function () {
      if (this.$route.params.hasOwnProperty('id')) {
        return 'always'
      }
      return 'never'
    }
  },
  methods: {
    getId() {
      if (this.$route.params.hasOwnProperty('id')) {
        this.model.id = this.$route.params.id
        this.inRoute = true
      } else {
        this.model.id = this.id
      }
    },
    solicitudHistorica() {
      this.getSolicitudHistoricaView(this.model.id)
        .then(response => {
          this.$log.debug('getSolicitudHistoricaView', this.model.id, response.data.statusCode)
          if (response.data.statusCode === 200) {
            const data = JSON.parse(response.data.datos);
            this.$log.debug(data)

            this.convertDataToModel(data)

            this.errored = false
          } else {
            this.messageError(response.data.statusCode)
          }
        })
        .catch(err => {
          this.$log.fatal('getSolicitudHistoricaView', err, this.model.id)
          this.messageError(err.request.status)
        })
        .finally(() => {
          this.loading = false
        })
    },
    convertDataToModel(data = {}) {
      this.model.rut = data.cedula
      this.model.nombreCompleto = data.nombrecompleto
      this.model.fechaIngreso = moment(data.fecha).format('DD-MM-YYYY')
      this.model.email = data.email
      this.model.estado = data.estado
      this.model.estadoCodigo = data.estadocodigo

      const mfecha = moment.utc(data.fecha).local()
      this.model.fecha = mfecha.format('DD-MM-YYYY')
      this.model.hora = mfecha.format('h:mm a')
    },
    messageError(statusCode) {
      this.errored = true
      let message = 'Ocurrió un error inesperado al cargar la solicitud Histórica'
      if (statusCode === 404) {
        message = 'La solicitud Histórica no existe'
      }
      this.showError(message)
      this.$emit('on-error-close', true)
    },
  },

}
</script>
